<app-navigation-bar data-test-id="navigation-bar" class="h-full" [routes]="getNavigationRoutes()"></app-navigation-bar>
